import React from 'react'

const Social = () => {
  return (
    <div className='home__social'>
        <a href='https://github.com/salarMokhtariL' className='home__social-icon' target="_blank">
          <i class="uil uil-github-alt"></i>
        </a>

        <a href='https://www.linkedin.com/in/salar-mokhtari-laleh-22508b91/' className='home__social-icon' target="_blank">
            <i class="uil uil-linkedin-alt"></i>
        </a>

        <a href='mailto: salarmokhtari0@gmail.com' className='home__social-icon' target="_blank">
        <i class="uil uil-envelopes"></i>        </a>

    </div>
  )
}

export default Social